import _asyncToGenerator from "/var/jenkins_home/workspace/ug-quartz-client-prod/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
// Element
// import ElementUI from 'element-ui'
// const ElementUI = require('element-ui')
import 'element-ui/lib/theme-chalk/index.css'; // flex 布局库

import 'flex.css';
import '@/components'; // 导入u8 iconfont

import '@/assets/icons/u8/iconfont.css'; // 剪贴板

import VueClipboard from 'vue-clipboard2'; // const VueClipboard = require('vue-clipboard2')
// form-create 动态表单

import formCreate from '@form-create/element-ui'; // const formCreate = require('@form-create/element-ui')
// echarts
// import ECharts from 'vue-echarts'

var ECharts = require('vue-echarts'); // import 'echarts/lib/chart/bar'
// import 'echarts/lib/chart/line'
// import 'echarts/lib/component/tooltip'
// import 'echarts/lib/component/legend'
// import 'echarts/lib/component/dataset'
// import 'echarts/lib/component/title'
// import 'echarts/lib/component/dataZoom'
// import 'echarts/lib/component/timeline'
// 功能插件


import pluginOpen from '@/plugin/open';
import pluginResponsive from '@/plugin/responsive';
export default {
  install: function install(Vue, options) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // 设置为 false 以阻止 vue 在启动时生成生产提示
              Vue.config.productionTip = false; // 当前环境

              Vue.prototype.$env = process.env.NODE_ENV; // 当前的 baseUrl

              Vue.prototype.$baseUrl = process.env.BASE_URL; // 当前版本

              Vue.prototype.$version = process.env.VUE_APP_VERSION; // 构建时间

              Vue.prototype.$buildTime = process.env.VUE_APP_BUILD_TIME; // Vue.use(ElementUI)

              Vue.use(pluginOpen);
              Vue.use(pluginResponsive);
              Vue.use(VueClipboard);
              Vue.use(formCreate);
              Vue.component('v-chart', ECharts);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};